const DEFAULT_PANEL_SPAN = 4;
const GRID_CELL_HEIGHT = 30;
const GRID_CELL_VMARGIN = 8;
const GRID_COLUMN_COUNT = 24;

export { DEFAULT_PANEL_SPAN, GRID_CELL_HEIGHT, GRID_CELL_VMARGIN, GRID_COLUMN_COUNT };
//# sourceMappingURL=constants.js.map
